<template>
  <b-form-group
    :label="`${label + asterisk}`"
    :label-for="`input-${name}-${_uid}`"
    :label-class="{
      'label-light-grey': focused || isOpen,
    }"
  >
    <v-select
      :id="`input-${name}-${_uid}`"
      :class="{
        'open-select': focused || isOpen,
        'is-valid': $parent.$v[name].$dirty ? !$parent.$v[name].$error : null,
      }"
      :clearable="false"
      :options="options"
      v-model.lazy="value"
      v-bind="$attrs"
      @search:focus="focused = true"
      @search:blur="focused = false"
    >
			<span slot="no-options">Nenhum resultado encontrado.</span>
    </v-select>
  </b-form-group>
</template>
<script>
import OpenIndicator from "@/components/Form/Inputs/OpenIndicator";
import vSelect from "vue-select";

vSelect.props.components.default = () => ({ OpenIndicator });

export default {
  name: "SelectComponent",
  props: ["name", "label", "options", "required"],
  components: {
    vSelect,
  },
  data() {
    return {
      value: this.$attrs.value,
      focused: false,
    };
  },
  watch: {
    focused: function() {
      return this.focused;
    },
    value: function() {
      this.$parent.$v[this.name].$touch();
      this.$emit("input", this.value.value ? this.value.value : this.value);
    },
  },
  computed: {
    asterisk: function() {
      return this.required ? "*" : "";
    },
    isOpen: function() {
      return this.value;
    },
  },
};
</script>
<style lang="scss"></style>
